import { useState } from "react";
import { Link } from "react-router-dom";
import SectionHeader from "@/components/feature/SectionHeader";
import { getAllVideos } from "@/lib/videoService";

const tabs = ["综合热度", "评分最高"] as const;

export default function HotRecommend() {
  const [tab, setTab] = useState<(typeof tabs)[number]>("综合热度");

  const sorted = getAllVideos()
    .slice()
    .sort((a, b) => (tab === "综合热度" ? b.heat - a.heat : b.rating - a.rating))
    .slice(0, 10);

  return (
    <section className="w-full px-4 md:px-8 mt-14 md:mt-16">
      <SectionHeader title="热门推荐" description="根据热度与口碑精选，看看大家都在追什么" />
      <div className="inline-flex items-center gap-1 bg-background-100 p-1 rounded-full mb-5">
        {tabs.map((item) => (
          <button
            key={item}
            type="button"
            onClick={() => setTab(item)}
            className={`px-4 py-1.5 rounded-full text-sm font-label whitespace-nowrap transition-colors ${
              tab === item ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-foreground-900"
            }`}
          >
            {item}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-8 gap-y-1">
        {sorted.map((video, index) => (
          <Link
            key={video.id}
            to={`/detail/${video.id}`}
            className="group flex items-center gap-3 py-3 border-b border-background-200/70 cursor-pointer"
          >
            <span
              className={`flex items-center justify-center w-7 h-7 rounded-md font-heading text-sm font-bold shrink-0 ${
                index < 3 ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-500"
              }`}
            >
              {index + 1}
            </span>
            <div className="w-12 h-16 rounded-md overflow-hidden shrink-0 bg-background-200">
              <img
                src={video.cover}
                alt={`${video.title}封面`}
                title={`${video.title} - 芭乐视频热门推荐`}
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="min-w-0 flex-1">
              <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-primary-600 transition-colors">
                {video.title}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 truncate">
                {video.type} · {video.region} · {video.year}
              </p>
              <p className="mt-0.5 text-xs text-foreground-400 truncate">{video.genre.join(" / ")}</p>
            </div>
            <div className="flex flex-col items-end gap-1 shrink-0">
              <span className="flex items-center gap-1 text-xs font-label text-accent-700">
                <i className="ri-star-fill" /> {video.rating.toFixed(1)}
              </span>
              <span className="flex items-center gap-1 text-xs font-label text-foreground-400">
                <i className="ri-fire-fill text-primary-500" /> {(video.heat / 1000).toFixed(1)}k
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}